var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgACause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 463,
    viewBox: "0 0 462 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 462.965V41.0125L40.927 0H421.073L462 41.0125V462.965H243.537V347.241C243.537 343.707 242.454 340.732 240.254 338.318C238.054 335.903 235.4 334.679 232.327 334.679H231C227.473 334.679 224.505 336.008 222.095 338.633C219.686 341.292 218.463 344.372 218.463 347.906V463H0V462.965ZM222.095 182.561C224.505 185.221 227.473 186.516 231 186.516C234.527 186.516 237.495 185.186 239.905 182.561C242.314 179.902 243.537 176.823 243.537 173.288V116.424C243.537 112.889 242.314 109.81 239.905 107.15C237.495 104.491 234.527 103.196 231 103.196H229.673C226.6 103.196 223.946 104.421 221.746 106.835C219.546 109.25 218.463 112.224 218.463 115.759V173.288C218.463 176.823 219.686 179.902 222.095 182.561Z",
    fill: "#FEFEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgACause);
export default __webpack_public_path__ + "static/media/A-Cause.875d5c01d46bf6bb08b4ee01559bc3cd.svg";
export { ForwardRef as ReactComponent };